"use strict";
/**
 * Entry point for the application
 * Dynamic import of bootstrap to enable async module loading
 */
import("./app/bootstrap");
